<template>
    <base-modal :ref="modal.key" :show="open" :title="plugin.name" @on-cancel="hide()" :okText="$t('Save')"
        :closeText="$t('Close')" :maxWidth="modalWidth" :fullscreen="fullscreen" :showConfirmButton="false"
        :showCancelButton="false" :infoText="versionDataText">
        <component :is="pluginContent" :ref="pluginKey" :documentList="documents" :pluginID="plugin.id"
            :pluginConfig="plugin.pluginConfig" @plugin-close="pluginClose"
            @plugin-version-data="showPluginVersionData" />
    </base-modal>
</template>
<script>
import Plugin from '@/ecm/models/plugin/Plugin';
import ExternalComponent from '@/ecm/common/ExternalComponent';
import { EventBus } from '@/eventBus.js';

export default {
    name: 'PluginLoaderModal',
    data() {
        return {
            modal: {
                title: this.$t('Plugin'),
                key: 'pluginLoaderModalKey',
            },
            open: false,
            fullscreen: false,
            modalWidth: '75%',
            plugin: new Plugin(),
            pluginContent: '',
            documents: [],
            pluginKey: 'pluginKey',
            pluginVersionData: null,
        };
    },
    computed: {
        pluginInstance() {
            return this.$refs[this.pluginKey];
        },
        versionDataText() {
            if (
                this.pluginVersionData &&
                this.pluginVersionData.version &&
                this.pluginVersionData.dateLastModified
            ) {
                return `${this.$t('Version')} ${this.pluginVersionData.version} - ${this.pluginVersionData.dateLastModified
                }`;
            } else {
                return '';
            }
        },
    },
    methods: {
        load(plugin, documents) {
            this.plugin = plugin;
            this.documents = documents;
            if (plugin.pluginConfig && plugin.pluginConfig.modalWidth) {
                this.modalWidth = plugin.pluginConfig.modalWidth;
            } else {
                this.modalWidth = '75%';
            }
            if (plugin.pluginConfig && plugin.pluginConfig.fullscreen) {
                this.fullscreen = plugin.pluginConfig.fullscreen;
            } else {
                this.fullscreen = false;
            }
            this.pluginContent = () =>
                ExternalComponent(
                    `plugin/load/${this.plugin.id}`,
                    plugin.pluginContentFileName
                );
            //FOR TESTING ADDONS
            //this.pluginContent = () => import('@/addons/ExportToBexio');
            this.show();
        },
        pluginClose(refreshResults, objectIDs) {
            if (refreshResults) {
                if (objectIDs) {
                    this.$emit('on-refresh-results', objectIDs);
                } else {
                    this.$emit('on-refresh-results');
                }
            }
            this.hide();
        },
        showPluginVersionData(pluginVersionData) {
            this.pluginVersionData = pluginVersionData;
        },
        save() {
            EventBus.$emit('pluginSaveClick');
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>